import { PureComponent } from 'react';
import moment from 'moment';

import { Alert, Layout } from 'antd';

import constants from 'constants/index';
import './GuestLayout.scss';


const { Content, Footer } = Layout;

interface GuestLayoutProp {
  location?: any,
  history?: any,
  version?: string,
}

class GuestLayout extends PureComponent<GuestLayoutProp> {

  gotoUrl = (url: string) => {
    this.props.history.push(url);
  };

  render() {
    const { children } = this.props;

    return (
      <Layout className="guest-layout">
        {children}
      </Layout>
    );
  }
}

export default GuestLayout;
